/**
 * @generated SignedSource<<004d741c01302ec60ba3a965c1ad776b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskModalIntro_viewer$data = {
  readonly getHelpCmsTopics: ReadonlyArray<{
    readonly groupKey: string | null;
    readonly topics: ReadonlyArray<{
      readonly topicKey: string | null;
      readonly topicLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly user?: {
    readonly profile: {
      readonly firstName: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticlesSearch_viewer" | "GetHelpZendeskBrowseByTopic_viewer">;
  readonly " $fragmentType": "GetHelpZendeskModalIntro_viewer";
};
export type GetHelpZendeskModalIntro_viewer$key = {
  readonly " $data"?: GetHelpZendeskModalIntro_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskModalIntro_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskModalIntro_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "getHelpCmsTopicGroup",
      "kind": "LinkedField",
      "name": "getHelpCmsTopics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "getHelpCmsTopicGroupTopic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskArticlesSearch_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskBrowseByTopic_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0b4b91270e7131ee85d74ba0fa0396bf";

export default node;
